import { PrioritizationType } from '../../../api/campaignPrioritization';

/** Alias for prioritization type - used as classification method in this panel. */
export type ClassificationMethod = PrioritizationType;

export interface TierLabel {
  id: string;
  label: string;
  criteria: string;
}

export interface ProspectClassificationConfig {
  classificationMethod: ClassificationMethod;
  /** Used when classificationMethod is 'scoring' - describes how to rank prospects */
  scoreInstructions: string;
  /** Used when classificationMethod is 'tiering' - labels with their criteria */
  tierLabels: TierLabel[];
  /** Used when classificationMethod is 'qualifying' - what makes a prospect qualified */
  qualifiedCriteria: string;
  /** Used when classificationMethod is 'qualifying' - what makes a prospect unqualified */
  unqualifiedCriteria: string;
}

export const defaultClassificationConfig: ProspectClassificationConfig = {
  classificationMethod: PrioritizationType.SCORING,
  scoreInstructions: '',
  tierLabels: [],
  qualifiedCriteria: '',
  unqualifiedCriteria: ''
};
